import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { observeTimeline } from '../render/dom/scroll/observe.mjs';
import { supportsScrollTimeline } from '../render/dom/scroll/supports.mjs';
var GroupPlaybackControls = /*#__PURE__*/function () {
  function GroupPlaybackControls(animations) {
    var _this = this;
    _classCallCheck(this, GroupPlaybackControls);
    // Bound to accomodate common `return animation.stop` pattern
    this.stop = function () {
      return _this.runAll("stop");
    };
    this.animations = animations.filter(Boolean);
  }
  return _createClass(GroupPlaybackControls, [{
    key: "then",
    value: function then(onResolve, onReject) {
      return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */
  }, {
    key: "getAll",
    value: function getAll(propName) {
      return this.animations[0][propName];
    }
  }, {
    key: "setAll",
    value: function setAll(propName, newValue) {
      for (var i = 0; i < this.animations.length; i++) {
        this.animations[i][propName] = newValue;
      }
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      var _this2 = this;
      var cancelAll = this.animations.map(function (animation) {
        if (supportsScrollTimeline() && animation.attachTimeline) {
          animation.attachTimeline(timeline);
        } else {
          animation.pause();
          return observeTimeline(function (progress) {
            animation.time = animation.duration * progress;
          }, timeline);
        }
      });
      return function () {
        cancelAll.forEach(function (cancelTimeline, i) {
          if (cancelTimeline) cancelTimeline();
          _this2.animations[i].stop();
        });
      };
    }
  }, {
    key: "time",
    get: function get() {
      return this.getAll("time");
    },
    set: function set(time) {
      this.setAll("time", time);
    }
  }, {
    key: "speed",
    get: function get() {
      return this.getAll("speed");
    },
    set: function set(speed) {
      this.setAll("speed", speed);
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.getAll("startTime");
    }
  }, {
    key: "duration",
    get: function get() {
      var max = 0;
      for (var i = 0; i < this.animations.length; i++) {
        max = Math.max(max, this.animations[i].duration);
      }
      return max;
    }
  }, {
    key: "runAll",
    value: function runAll(methodName) {
      this.animations.forEach(function (controls) {
        return controls[methodName]();
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.runAll("play");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.runAll("pause");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.runAll("cancel");
    }
  }, {
    key: "complete",
    value: function complete() {
      this.runAll("complete");
    }
  }]);
}();
export { GroupPlaybackControls };